import React from 'react'
import styled, { css } from 'styled-components'
import { BodyCopy, H2, H3 } from './Typography'
import media from 'css-in-js-media'

export const StyledTitle = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: ${(props) => props.width || '100%'};

    ${H3} {
        font-size: 28px;
        line-height: 50px;
        letter-spacing: 0.005em;

        ${media('<desktop')} {
            font-size: 18px;
        }
    }

    ${(props) =>
        !props.noMargin &&
        !props.noMarginTop &&
        css`
            margin-top: 120px;
            margin-bottom: 80px;
            ${media('<desktop')} {
                margin-top: 60px;
                margin-bottom: 40px;
            }
        `}

    ${(props) =>
        props.noMarginTop == true &&
        css`
            margin-bottom: 80px;
        `}

    ${BodyCopy} {
        font-size: 20px;
        line-height: 100%;
        letter-spacing: 0.1em;   
        
        ${media('<desktop')} {
            font-size: 18px;
            line-height: 130%;
        }
    }

    ${(props) =>
        props.align == 'left' &&
        css`
            max-width: 640px;
            margin-top: 120px;
            margin-left: 10.8%;
            margin-bottom: 60px;
            ${media('<desktop')} {
                margin-left: 20px;
                margin-right: 20px;
                margin-top: 80px;
                margin-bottom: 30px;
            }
            ${H2} {
                max-width: 416px;
            }
        `}

    ${(props) =>
        props.align == 'center' &&
        css`
            text-align: center;
            ${media('<desktop')} {
                margin-left: 20px;
                margin-right: 20px;
                text-align: left;
            }
        `}
`

const Title = ({ children, ...props }) => {
    return <StyledTitle {...props}>{children}</StyledTitle>
}

export default Title
